import formatCurrency from './formatCurrency';
import getNumericCharactersOnlyAndConvertToInt from './getNumericCharactersOnlyAndConvertToInt';

export default function formatCurrencyInput(input) {
  let { value } = input;
  if (value !== '' && typeof value === 'string') {
    value = getNumericCharactersOnlyAndConvertToInt(value);

    // eslint-disable-next-line no-param-reassign
    input.value = Number.isNaN(value) ? '$' : formatCurrency(value);
  }
}
